import { NumberedItem } from '../../ui-components/NumberedItem'
import { EliteScoreTrends, KnowWhyAPIReponseType } from '../../../types/mutual-fund-detail.types'
import { toPascalCaseWithSpaces } from '../../../utils/utils'
import { getScoreConfig } from '../utils'
import { GradientStrip } from '../../ui-components/GradientStrip'
import { StripContent } from './StripContent'
import { formatScoreOfTotalSpeech } from './ScoreValue'

interface RecencyScoreSectionProps {
  knowWhyData: KnowWhyAPIReponseType
  isElite: boolean
  number: number
  isLastSection: boolean
}

export const RecencyScoreSection = ({
  knowWhyData,
  isElite,
  number,
  isLastSection
}: RecencyScoreSectionProps) => {
  const category = toPascalCaseWithSpaces(knowWhyData?.category ?? '')
  const recencyScore = knowWhyData?.scoringDetails?.recencyScore ?? 0
  const maxScore = knowWhyData?.scoringDetails?.maxScore ?? 100
  const tag = (knowWhyData?.scoringDetails?.recencyScorePerformanceTag || EliteScoreTrends.BAD) as EliteScoreTrends
  const config = getScoreConfig(tag)
  const scoreSpeech = formatScoreOfTotalSpeech(isElite ? recencyScore : null, maxScore, !isElite)
  const description = "Fund's recent performance over last 2 years vs others in same category"
  const accessibilityLabel = [
    `Recency Score in ${category}`,
    scoreSpeech,
    config.scoreLabel,
    description
  ].join(', ')

  return (
    <NumberedItem
      as='li'
      number={number}
      title={`Recency Score`}
      subtitle={`in ${category}`}
      borderBottom={!isLastSection}
      accessibilityLabel={accessibilityLabel}
    >
      <GradientStrip type={config.gradientStripType}>
        <StripContent
          tag={tag}
          isElite={isElite}
          score={recencyScore}
          maxScore={maxScore}
          description='Fund’s recent performance over last 2 <br /> years vs others in same category'
        />
      </GradientStrip>
    </NumberedItem>
  )
}
